<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#error__a)">
    <path fill-rule="evenodd" d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-7.027 4.973a1.656 1.656 0 0 0 0-2.335l-2.638-2.639 2.638-2.637a1.656 1.656 0 0 0 0-2.335 1.656 1.656 0 0 0-2.335 0L12 9.664 9.362 7.027a1.656 1.656 0 0 0-2.335 0 1.656 1.656 0 0 0 0 2.335L9.665 12l-2.638 2.639a1.656 1.656 0 0 0 0 2.335 1.656 1.656 0 0 0 2.335 0L12 14.336l2.638 2.637a1.656 1.656 0 0 0 2.335 0Z"/>
  </g>
  <defs>
    <clipPath id="error__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
